export enum LocalStorageKeys {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  IS_LOGIN_PENDING = 'isLoginPending',
  USER = 'user',
  KEEP_ME_SIGNED_IN = 'keepMeSignedIn',
}

class LocalStorageService {
  static set<T>(key: LocalStorageKeys, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting localStorage key “${key}”:`, error);
    }
  }

  static get<T>(key: LocalStorageKeys): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) as T : null;
    } catch (error) {
      console.error(`Error getting localStorage key “${key}”:`, error);
      return null;
    }
  }

  static remove(key: LocalStorageKeys): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing localStorage key “${key}”:`, error);
    }
  }
}

export default LocalStorageService;